import React, { useContext, useEffect, useState } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  Image,
  StyleSheet,
  ScrollView,
  Dimensions,
  PixelRatio,
  ActivityIndicator,
  Modal,
  Platform,
} from "react-native";
import * as ImagePicker from "expo-image-picker"; // or your preferred library
import { useNavigation, useRoute } from "@react-navigation/native";
import axios from "../../api/axios";
import Colours from "../../utils/Colours";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import SuccessAlertComp from "../../alertComp/SuccessAlertComp";
import useAuth from "../../hooks/useAuth";
import AppContext from "../../context/AppContext";

const { width, height } = Dimensions.get("window");

// --- RESPONSIVE TOOLKIT ---
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  return Math.round(PixelRatio.roundToNearestPixel(size * scaleFactor));
};

const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const IdentityScreen = () => {
  const navigation = useNavigation();
  const route = useRoute();
  const { registrationData } = route.params || {};
  const { googleOnboardData, setAuth, isLoggedIn } = useContext(AppContext);

  //console.log("registrationDataxt", registrationData);
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [isLoadingImage, setIsLoadingImage] = useState(false);
  const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [username, setUsername] = useState(
    registrationData?.username || googleOnboardData?.username || "",
  );
  const [isAvailable, setIsAvailable] = useState(null); // null, true, or false
  const [checking, setChecking] = useState(false);
  const [loading, setLoading] = useState(false);
  const [profileImage, setProfileImage] = useState(
    googleOnboardData?.profilePicture || "https://api.dicebear.com/7.x/pixel-art/svg?seed=Meeza",
  );

  const { isGuest } = useAuth();

  // Determine if this is a Google flow based on whether that context data exists
  const isGoogleAuth = googleOnboardData?.isGoogleAuth || false;

  console.log("popcultuer", googleOnboardData);

  useEffect(() => {
    if (googleOnboardData) {
      console.log("Context data loaded successfully! Syncing inputs:", googleOnboardData);
      setUsername(googleOnboardData.username || "");
    }
  }, [googleOnboardData]);

  // Debounce effect: Wait 500ms after the user stops typing before checking API
  useEffect(() => {
    if (username.length < 3) {
      setIsAvailable(null);
      return;
    }

    //console.log()

    const delayDebounceFn = setTimeout(() => {
      checkUsernameAvailability(username);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [username]);

  const checkUsernameAvailability = async (name) => {
    setChecking(true);
    try {
      // Replace with your actual endpoint
      //   const response = await axios.get(`/auth/check-username?username=${name.toLowerCase()}`);
      const response = await axios.get(
        `/usernameSearching/usernameSearching/${name.trim().toLowerCase()}`,
      );
      if (response.data.available) {
        // Assuming backend returns { available: true }
        setIsAvailable(response.data.available);
      } else {
        // Show red border / "Username taken" text
      }
    } catch (error) {
      console.error("Availability Check Error", error);
      setIsAvailable(false);
    } finally {
      setChecking(false);
    }
  };

  const handlePickImage = async () => {
    try {
      setIsLoadingImage(true);

      let result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: true,
        aspect: [1, 1],
        quality: 1,
      });
      // if (!result.canceled) setProfileImage(result.assets[0].uri);

      if (result.canceled) return; // Exit early if the user canceled

      const currentAsset = result.assets[0];
      const imageUri = currentAsset.uri;
      let fileSizeInMB = 0;

      // 🌟 CROSS-PLATFORM FILE SIZE CHECK (Web safe)
      if (Platform.OS === "web") {
        if (currentAsset.file) {
          fileSizeInMB = currentAsset.file.size / (1024 * 1024);
        } else {
          // Fallback web blob fetch evaluation if the file handle isn't attached directly
          const response = await fetch(imageUri);
          const blob = await response.blob();
          fileSizeInMB = blob.size / (1024 * 1024);
        }
      } else {
        // Native Device file size check using expo-file-system
        const fileInfo = await FileSystem.getInfoAsync(imageUri);
        fileSizeInMB = fileInfo.size / (1024 * 1024);
      }

      // Guardrail size boundary validation check
      if (fileSizeInMB > 65) {
        setErrorMessage(
          `Image too large: The selected image is ${fileSizeInMB.toFixed(2)} MB. Please choose another.`,
        );
        setIsErrorCompVisible(true);
        return; // Stop further state execution
      }

      // Update your hook state with the verified safe image URI string
      setProfileImage(imageUri);
    } catch (error) {
      console.error("Error picking image:", error);
    } finally {
      setIsLoadingImage(false); // Clean up the loading wheel state regardless of outcome
    }
  };

  // const handleCreateUser = async () => {
  //   // 1. Final local check (Safety first!)
  //   setLoading(true); // Start spinner
  //   try {
  //     // Replace with your actual endpoint
  //     //   const response = await axios.get(`/auth/check-username?username=${name.toLowerCase()}`);
  //     const response = await axios.get(
  //       `/usernameSearching/usernameSearching/${name.trim().toLowerCase()}`,
  //     );
  //     if (!response.data.available) {
  //       // Assuming backend returns { available: true }
  //       setIsAvailable(false);
  //       return;
  //     }
  //   } catch (error) {
  //     console.error("Availability Check Error", error);
  //     setIsAvailable(false);
  //   }

  //   // finally {
  //   //   setChecking(false);
  //   // }

  //   if (!username.trim() || !isAvailable) {
  //     setErrorMessage("Please choose a valid and available username.");
  //     setIsErrorCompVisible(true);
  //     return;
  //   }

  //   // setLoading(true); // Start spinner

  //   try {
  //     const formData = new FormData();

  //     // Check if the image is a local file (starts with 'file://' or 'content://')
  //     const isNewImage =
  //       registrationData.profilePicture.startsWith("file") ||
  //       registrationData.profilePicture.startsWith("content");

  //     if (isNewImage) {
  //       // 1. User selected a new file - Attach to the file field
  //       formData.append("profilePhoto", {
  //         uri: registrationData.profilePicture,
  //         name: "profile.jpg",
  //         type: "image/jpeg",
  //       });
  //     } else {
  //       // 2. Still using the DiceBear URL - Send as a text field
  //       formData.append("defaultProfileUrl", registrationData.profilePicture);
  //     }
  //     // 3. Append the rest of the text data
  //     formData.append("firstname", registrationData.firstname);
  //     formData.append("lastname", registrationData.lastname);
  //     formData.append("email", registrationData.email);
  //     formData.append("password", registrationData.password);
  //     formData.append("phoneNumber", registrationData.phoneNumber);
  //     formData.append("username", username.trim().toLowerCase());

  //     // 3. Send the POST request
  //     const response = await axios.post("/updateGuestUser/updateGuestUser/", formData, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });

  //     if (response.status === 200 || response.status === 201) {
  //       setSuccessMessage("Your account has been created successfully!");
  //       setIsSuccessCompVisible(true);

  //       // Optional: Delay navigation so user sees the success message
  //       setTimeout(() => {
  //         setIsSuccessCompVisible(false);
  //         navigation.replace("log_in"); // Use replace to prevent going back to registration
  //       }, 2000);
  //     }
  //   } catch (error) {
  //     console.error("Account Creation Error:", error);

  //     // Extract error message from backend if available
  //     const errorMsg =
  //       error.response?.data?.message || "Failed to create account. Please try again.";
  //     setErrorMessage(errorMsg);
  //     setIsErrorCompVisible(true);
  //   } finally {
  //     setLoading(false); // Stop spinner
  //   }
  // };

  const isUsernameForbidden = username.toLowerCase().startsWith("guest_");

  // const handleCreateUser = async () => {
  //   setLoading(true); // Start spinner

  //   const cleanUsername = username.trim().toLowerCase();

  //   try {
  //     // 1. FINAL USERNAME AVAILABILITY CHECK
  //     const checkResponse = await axios.get(
  //       `/usernameSearching/usernameSearching/${username.trim().toLowerCase()}`,
  //     );

  //     if (!checkResponse.data.available) {
  //       setIsAvailable(false);
  //       // setErrorMessage("This username was just taken. Please try another one.");
  //       // setIsErrorCompVisible(true);
  //       setLoading(false); // Must stop spinner manually here
  //       return; // ⛔ STOP: The rest of the code will not run
  //     }

  //     if (cleanUsername.startsWith("guest")) {
  //       setErrorMessage("You must change your username from the default 'Guest_' prefix.");
  //       setIsErrorCompVisible(true);
  //       setLoading(false);
  //       return; // ⛔ STOP
  //     }

  //     // 2. PREPARE FORM DATA
  //     const formData = new FormData();

  //     // Check if the image is a local file
  //     const isNewImage =
  //       registrationData.profilePicture.startsWith("file") ||
  //       registrationData.profilePicture.startsWith("content");

  //     if (isNewImage) {
  //       formData.append("profilePhoto", {
  //         uri: registrationData.profilePicture,
  //         name: "profile.jpg",
  //         type: "image/jpeg",
  //       });
  //     } else {
  //       formData.append("defaultProfileUrl", registrationData.profilePicture);
  //     }

  //     // Append text data
  //     formData.append("firstname", registrationData.firstname);
  //     formData.append("lastname", registrationData.lastname);
  //     formData.append("email", registrationData.email);
  //     formData.append("password", registrationData.password);
  //     formData.append("phoneNumber", registrationData.phoneNumber);
  //     formData.append("username", username.trim().toLowerCase());

  //     // 3. SEND UPDATE REQUEST
  //     const response = await axios.post("/updateGuestUser/updateGuestUser/", formData, {
  //       headers: { "Content-Type": "multipart/form-data" },
  //     });

  //     // 4. HANDLE SUCCESS
  //     if (response.status === 200 || response.status === 201) {
  //       setSuccessMessage("Your account has been created successfully!");
  //       setIsSuccessCompVisible(true);

  //       setTimeout(() => {
  //         setIsSuccessCompVisible(false);
  //         if (isGuest) {
  //           navigation.replace("main");
  //         } else {
  //           navigation.replace("log_in");
  //         }
  //       }, 2000);
  //     }
  //   } catch (error) {
  //     console.error("Critical Error:", error);
  //     const errorMsg = error.response?.data?.message || "An unexpected error occurred.";
  //     setErrorMessage(errorMsg);
  //     setIsErrorCompVisible(true);
  //   } finally {
  //     setLoading(false); // Stop spinner globally for both success and catches
  //   }
  // };

  // const handleCreateUser = async () => {
  //   setLoading(true); // Start spinner

  //   const selectedPicture =  registrationData?.profilePicture || profileImage

  //   const cleanUsername = username.trim().toLowerCase();

  //   try {
  //     // 1. FINAL USERNAME AVAILABILITY CHECK
  //     const checkResponse = await axios.get(
  //       `/usernameSearching/usernameSearching/${cleanUsername}`,
  //     );

  //     if (!checkResponse.data.available) {
  //       setIsAvailable(false);
  //       // setErrorMessage("This username was just taken. Please try another one.");
  //       // setIsErrorCompVisible(true);
  //       return;
  //     }

  //     if (cleanUsername.startsWith("guest")) {
  //       setErrorMessage("You must change your username from the default 'Guest' prefix.");
  //       setIsErrorCompVisible(true);
  //       return;
  //     }

  //     // 2. PREPARE FORM DATA
  //     const formData = new FormData();

  //     // 🌟 PWA / WEB FIX: Detect and convert web blobs safely
  //     const isBlobUrl = registrationData.profilePicture?.startsWith("blob:");
  //     const isLocalFile =
  //       registrationData.profilePicture?.startsWith("file:") ||
  //       registrationData.profilePicture?.startsWith("content:");

  //     if (isBlobUrl) {
  //       // Fetch the binary data directly out of the local PWA memory pool
  //       const blobResponse = await fetch(registrationData.profilePicture);
  //       const imageBlob = await blobResponse.blob();

  //       // Append the real binary File/Blob payload directly for standard multer consumption
  //       formData.append("profilePhoto", imageBlob, "profile.jpg");
  //     } else if (isLocalFile) {
  //       // Native Fallback Architecture
  //       formData.append("profilePhoto", {
  //         uri: registrationData.profilePicture,
  //         name: "profile.jpg",
  //         type: "image/jpeg",
  //       });
  //     } else {
  //       // Remote fallback string reference pointer
  //       formData.append("defaultProfileUrl", registrationData.profilePicture);
  //     }

  //     // Append remaining string input elements safely
  //     formData.append("firstname", registrationData.firstname);
  //     formData.append("lastname", registrationData.lastname);
  //     formData.append("email", registrationData.email);
  //     formData.append("password", registrationData.password);
  //     formData.append("phoneNumber", registrationData.phoneNumber);
  //     formData.append("username", cleanUsername);

  //     // 3. SEND UPDATE REQUEST
  //     const response = await axios.post("/updateGuestUser/updateGuestUser/", formData, {
  //       headers: { "Content-Type": "multipart/form-data" },
  //     });

  //     // 4. HANDLE SUCCESS
  //     if (response.status === 200 || response.status === 201) {
  //       setSuccessMessage("Your account has been created successfully!");
  //       setIsSuccessCompVisible(true);

  //       setTimeout(() => {
  //         setIsSuccessCompVisible(false);
  //         if (isGuest) {
  //           navigation.replace("main");
  //         } else {
  //           navigation.replace("log_in");
  //         }
  //       }, 2000);
  //     }
  //   } catch (error) {
  //     console.error("Critical Error during user instantiation lifecycle:", error);
  //     const errorMsg = error.response?.data?.message || "An unexpected error occurred.";
  //     setErrorMessage(errorMsg);
  //     setIsErrorCompVisible(true);
  //   } finally {
  //     setLoading(false); // Cleanly shuts down spinner globally under all conditions
  //   }
  // };

  const handleCreateUser = async () => {
    setLoading(true); // Start spinner

    // Unified picture reference pointer
    const selectedPicture = registrationData?.profilePicture || profileImage;

    const cleanUsername = username.trim().toLowerCase();

    try {
      // 1. FINAL USERNAME AVAILABILITY CHECK
      const checkResponse = await axios.get(
        `/usernameSearching/usernameSearching/${cleanUsername}`,
      );

      if (!checkResponse.data.available) {
        setIsAvailable(false);
        // setErrorMessage("This username was just taken. Please try another one.");
        // setIsErrorCompVisible(true);
        return;
      }

      if (cleanUsername.startsWith("guest")) {
        setErrorMessage("You must change your username from the default 'Guest' prefix.");
        setIsErrorCompVisible(true);
        return;
      }

      // 2. PREPARE FORM DATA
      const formData = new FormData();

      // 🌟 PWA / WEB FIX: Detect and convert web blobs safely using selectedPicture
      const isBlobUrl = selectedPicture?.startsWith("blob:");
      const isLocalFile =
        selectedPicture?.startsWith("file:") || selectedPicture?.startsWith("content:");

      if (isBlobUrl) {
        // Fetch the binary data directly out of the local PWA memory pool
        const blobResponse = await fetch(selectedPicture);
        const imageBlob = await blobResponse.blob();

        // Append the real binary File/Blob payload directly for standard multer consumption
        formData.append("profilePhoto", imageBlob, "profile.jpg");
      } else if (isLocalFile) {
        // Native Fallback Architecture
        formData.append("profilePhoto", {
          uri: selectedPicture,
          name: "profile.jpg",
          type: "image/jpeg",
        });
      } else {
        // Remote fallback string reference pointer
        formData.append("defaultProfileUrl", selectedPicture);
      }

      // Append remaining string input elements safely
      formData.append(
        "firstname",
        registrationData?.firstname || googleOnboardData?.firstname || "",
      );
      formData.append("lastname", registrationData?.lastname || googleOnboardData?.lastname || "");
      formData.append("email", registrationData?.email || googleOnboardData?.email || "");
      formData.append("password", registrationData?.password || "");
      formData.append("phoneNumber", registrationData?.phoneNumber || "");
      formData.append("username", cleanUsername);

      // 3. SEND UPDATE REQUEST
      const response = await axios.post("/updateGuestUser/updateGuestUser/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // 4. HANDLE SUCCESS
      if (response.status === 200 || response.status === 201) {
        setSuccessMessage("Your account has been created successfully!");
        setIsSuccessCompVisible(true);

        if (isGoogleAuth) {
          setAuth((prev) => ({
            ...prev,
            isProfileComplete: true,
          }));

          //STEP B: Fire the silent-refresh engine to pull a fresh access token from the server!
          if (isLoggedIn) {
            await isLoggedIn();
          }
        }

        navigation.replace("log_in");

        setTimeout(() => {
          setIsSuccessCompVisible(false);
          // if (isGuest || isGoogleAuth) {
          //   navigation.replace("main");
          // } else {
          //   navigation.replace("log_in");
          // }
        }, 2000);
      }
    } catch (error) {
      console.error("Critical Error during user instantiation lifecycle:", error);
      const errorMsg = error.response?.data?.message || "An unexpected error occurred.";
      setErrorMessage(errorMsg);
      setIsErrorCompVisible(true);
    } finally {
      setLoading(false); // Cleanly shuts down spinner globally under all conditions
    }
  };

  return (
    <View style={[styles.container, { justifyContent: "center" }]}>
      <View style={styles.centralizedContent}>
        {isGoogleAuth ? (
          /* GOOGLE FLOW: Image is wrapped in an interactive pressable wrapper */
          isLoadingImage ? (
            <ActivityIndicator size={"small"} color={Colours.PRIMARY} />
          ) : (
            <View
              activeOpacity={0.7}
              // onPress={handlePickImage} // Your existing image picker function
              style={styles.profilePicContainer}
            >
              <Image
                source={{
                  uri:
                    profileImage ||
                    googleOnboardData?.profilePicture ||
                    "https://api.dicebear.com/7.x/pixel-art/svg?seed=Meeza",
                }}
                style={styles.largeProfilePic}
              />
              {/* Optional: Add a little edit badge/icon overlapping the picture */}
              {/* <View style={styles.editBadge}>
                <Text style={styles.editBadgeText}>Edit</Text>
              </View> */}
            </View>
          )
        ) : (
          <Image
            source={{
              uri:
                registrationData?.profilePicture ||
                "https://api.dicebear.com/7.x/pixel-art/svg?seed=Meeza",
            }}
            style={styles.largeProfilePic}
          />
        )}

        <Text style={styles.title}>Setup your identity</Text>
        <Text style={styles.subtitle}>This is how other users will see you.</Text>

        <View style={[styles.inputGroup, { width: "100%", marginTop: 30 }]}>
          <View
            style={[
              styles.usernameWrapper,
              isAvailable === true && { borderColor: "#4CAF50", borderWidth: 1 },
              isAvailable === false && { borderColor: "#F44336", borderWidth: 1 },
            ]}
          >
            <Text style={styles.atSymbol}>@</Text>
            <TextInput
              style={styles.usernameInput}
              placeholder="username"
              autoCapitalize="none"
              value={username}
              onChangeText={(text) => setUsername(text.replace(/\s/g, ""))} // Prevent spaces
            />
            {checking && <ActivityIndicator size="small" color="#000" />}
          </View>

          {/* Availability Feedback Message */}
          {username.length >= 3 && !checking && (
            <Text style={[styles.statusText, { color: isAvailable ? "#4CAF50" : "#F44336" }]}>
              {isAvailable ? "Username is available" : "Username is taken"}
            </Text>
          )}
        </View>

        <TouchableOpacity
          style={[
            styles.primaryButton,
            { width: "100%", marginTop: 20 },
            (!isAvailable || checking || loading || isUsernameForbidden) && { opacity: 0.5 },
          ]}
          disabled={!isAvailable || checking || loading || isUsernameForbidden}
          onPress={handleCreateUser}
        >
          {loading ? (
            <ActivityIndicator color={"white"} />
          ) : (
            <Text style={styles.buttonText}>Create Account</Text>
          )}
        </TouchableOpacity>
      </View>
      <Modal visible={isErrorCompVisible} transparent={true} animationType="fade">
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>
      <Modal visible={isSuccessCompVisible} transparent={true} animationType="fade">
        <SuccessAlertComp
          message={successMessage}
          onClose={() => {
            setIsSuccessCompVisible(false);
          }}
        />
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  // SHARED STYLES
  container: {
    flex: 1,
    backgroundColor: "#FFF",
  },
  primaryButton: {
    backgroundColor: "#000",
    height: dynamicSize(55),
    borderRadius: dynamicSize(12),
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  buttonText: {
    color: "#FFF",
    fontSize: 16,
    fontWeight: "bold",
  },

  // IDENTITY SCREEN SPECIFIC (CENTRALIZED)
  centralizedContent: {
    alignItems: "center",
    paddingHorizontal: dynamicSpacing(40),
    width: "100%",
  },
  largeProfilePic: {
    width: dynamicSize(120),
    height: dynamicSize(120),
    borderRadius: dynamicSize(30), // Slightly more squared than the first page
    marginBottom: dynamicSpacing(20),
  },

  // ADD THESE TO SUPPORT THE EDITABLE GOOGLE AUTH HOOK:
  profilePicContainer: {
    position: "relative",
    marginBottom: dynamicSpacing(20),
  },
  editBadge: {
    position: "absolute",
    bottom: dynamicSpacing(15),
    right: -dynamicSize(5),
    backgroundColor: "#007AFF",
    paddingVertical: dynamicSpacing(4),
    paddingHorizontal: dynamicSpacing(8),
    borderRadius: dynamicSize(10),
    borderWidth: 2,
    borderColor: "#FFF",
    elevation: 3,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 2,
  },
  editBadgeText: {
    color: "#FFF",
    fontSize: dynamicSize(11),
    fontWeight: "bold",
  },
  usernameWrapper: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#F5F5F5",
    borderRadius: dynamicSize(12),
    paddingHorizontal: 15,
    height: dynamicSize(55),
  },
  atSymbol: {
    fontSize: 18,
    fontFamily: "Sen-Bold",
    color: "#AAA",
    marginRight: 5,
  },
  usernameInput: {
    flex: 1,
    fontSize: 18,
    fontFamily: "Sen-Medium",
    color: "#000",
  },
  title: {
    fontSize: dynamicFontSize(24),
    fontFamily: "Sen-Bold",
    color: "#1A1A1A",
    marginBottom: 8,
    textAlign: "center",
  },
  subtitle: {
    fontSize: dynamicFontSize(14),
    color: "#666",
    textAlign: "center",
    fontFamily: "Sen-Regular",
  },

  statusText: {
    fontSize: dynamicFontSize(12),
    marginTop: dynamicSpacing(5),
    marginLeft: dynamicSpacing(5),
    fontFamily: "Sen-Medium",
  },
});

export default IdentityScreen;
